import { constants } from "../../common/constant/constants";
import { HttpHelper } from "../../common/helper/http-helper-service";

export default class TechnicianServices {
  constructor() {}

  static getTechnicianList = () => {
    return HttpHelper.getData(
      constants.apiUrl.technicianUrls.getTechniciansList,
    );
  };

  static getTechnician = (Email: string) => {
    let url =
      constants.apiUrl.technicianUrls.getTechnician +
      "?" +
      "Email=" +
      encodeURIComponent(Email);
    return HttpHelper.getData(url);
  };

  static joinSignalrGroupsByRole = () => {
    return HttpHelper.postData(
      constants.apiUrl.technicianUrls.joinSignalrGroupsByRole,
      {},
    );
  };

  static getClientMembershipGroups = () => {
    return HttpHelper.getData(
      constants.apiUrl.technicianUrls.getClientMembershipGroups,
    );
  };

  static getTechnicianListData = () => {
    return HttpHelper.getData(
      constants.apiUrl.technicianUrls.getTechniciansList,
    );
  };

  static getTechnicianListDataById = (Id: number) => {
    return HttpHelper.getData(
      constants.apiUrl.technicianUrls.getTechnicianById + "/" + Id,
    );
  };

  static async getTechnicianByTick(tick: number) {
    return HttpHelper.getData(
      constants.apiUrl.technicianUrls.getTechnicianByTick +
        "?storeTick=" +
        tick,
    );
  }

  static async getClientGroupsAndEmailConfiguration(clientId: number) {
    return HttpHelper.getData(
      constants.apiUrl.technicianUrls.getClientGroupsAndEmailConfiguration.replace(
        "{id}",
        clientId.toString(),
      ),
    );
  }

  static getTechnicianGroupList = () => {
    return HttpHelper.getData(
      constants.apiUrl.technicianUrls.getTechniciansGroupList,
    );
  };
}
